<template>
  <div v-if="offlineReady || needRefresh" class="lv-card fixed-top warning" role="alert">
    <div class="container d-flex flex-column justify-content-center align-items-center">
      <div class="message mt-1">
        <span v-if="offlineReady">Приложение не может работать без сети. </span>
        <span v-else>Необходимо обновить приложение.</span>
      </div>
      <div class="buttons flex align-middle mt-2 md:mt-0">
        <button v-if="needRefresh" @click="updateServiceWorker()" class="btn-lv-type-1">
          Обновить
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { useRegisterSW } from "virtual:pwa-register/vue";

const { updateServiceWorker } = useRegisterSW();

export default defineComponent({
  name: "ReloadPWA",
  setup() {
    const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW();
    const close = async () => {
      offlineReady.value = false;
      needRefresh.value = false;
    };
    return { offlineReady, needRefresh, updateServiceWorker, close };
  },
  methods: {
    async close() {
      this.offlineReady.value = false;
      this.needRefresh.value = false;
    },
    async updateServiceWorker() {
      await updateServiceWorker();
    },
  },
});
</script>
<style>
.warning {
  background-color: #fffae5 !important;
}
</style>
